import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';

interface CompanyStatsCardProps {
  activeUsers: number;
  userLimit: number;
  loading: boolean;
}

const CompanyStatsCard: React.FC<CompanyStatsCardProps> = ({ activeUsers, userLimit, loading }) => (
  <Card className="setting-card" title="Şirket İstatistikleri">
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} md={8}>
        <Statistic
          title="Aktif Çalışan Sayısı"
          value={activeUsers}
          suffix="kişi"
          loading={loading}
        />
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Statistic
          title="Kullanıcı Limiti"
          value={userLimit}
          suffix="kişi"
          loading={loading}
        />
      </Col>
    </Row>
  </Card>
);

export default CompanyStatsCard;
